import { render, staticRenderFns } from "./fission-share-award.vue?vue&type=template&id=e46621c0&scoped=true"
import script from "./fission-share-award.vue?vue&type=script&lang=js"
export * from "./fission-share-award.vue?vue&type=script&lang=js"
import style0 from "./fission-share-award.vue?vue&type=style&index=0&id=e46621c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46621c0",
  null
  
)

export default component.exports